export enum PricingItemScope {
  FIXED = 'FIXED',
  RANGE = 'RANGE',
}
